import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=c16a71f6"
import script from "../js/Root.js?vue&type=script&lang=js&external"
export * from "../js/Root.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports